import { applySdkMetadata, setTag } from '@sentry/core';
import { init as init$1 } from '@sentry/react';
export * from '@sentry/react';
export { captureRemixErrorBoundaryError } from './client/errors.js';
export { withSentry } from './client/performance.js';
export { browserTracingIntegration } from './client/browserTracingIntegration.js';

function init(options) {
  const opts = {
    ...options,
    environment: options.environment || process.env.NODE_ENV,
  };

  applySdkMetadata(opts, 'remix', ['remix', 'react']);

  init$1(opts);

  setTag('runtime', 'browser');
}

export { init };
//# sourceMappingURL=index.client.js.map
